export default {
  // Settings
  "settings": "Einstellungen",
  "profile": "Profil",
  "security": "Sicherheit",
  "theme": "Thema",
  "feedback": "Feedback",
  "data": "Daten",
  "appearance_settings": "Darstellungseinstellungen",
  "select_theme": "Wählen Sie Ihr bevorzugtes Thema",
  "light": "Hell",
  "dark": "Dunkel",
  "system": "System",
  "language_changed": "Sprache geändert zu",
  "failed_update_language": "Fehler beim Aktualisieren der Sprache",
  "profile_settings": "Profileinstellungen",
  "username_cannot_change": "Sie können Ihren Benutzernamen für",
  "more_days": "weitere Tage nicht ändern",
  "email_cannot_change": "E-Mail kann nicht geändert werden",
  "profile_links": "Profillinks",
  "link_one": "Link 1",
  "link_two": "Link 2",
  "password_change": "Passwort ändern",
  "current_password": "Aktuelles Passwort",
  "new_password": "Neues Passwort",
  "confirm_password": "Passwort bestätigen",
  "update_password": "Passwort aktualisieren",
  "password_must_be": "Das Passwort muss zwischen 8 und 25 Zeichen lang sein",
  "security_questions": "Sicherheitsfragen",
  "security_question": "Sicherheitsfrage",
  "update_security_questions": "Sicherheitsfragen aktualisieren",
  "setup_security_questions": "Sicherheitsfragen einrichten",
  "select_question": "Frage auswählen",
  "your_answer": "Ihre Antwort",
  "enter_your_answer": "Geben Sie Ihre Antwort ein",
  "submit_feedback": "Feedback senden",
  "feedback_type": "Feedback-Typ",
  "general_feedback": "Allgemeines Feedback",
  "bug_report": "Fehlerbericht",
  "feature_request": "Funktionsanfrage",
  "airport_request": "Neuen Flughafen anfragen",
  "airport_iata": "Flughafen IATA-Code",
  "airport_name": "Flughafenname",
  "airport_location": "Flughafenstandort",
  "your_feedback": "Ihr Feedback",
  "data_management": "Datenverwaltung",
  "delete_all_films": "Alle Filme löschen",
  "delete_films_warning": "Dies löscht dauerhaft alle Filme aus Ihrem Inventar. Diese Aktion kann nicht rückgängig gemacht werden.",
  "delete_all_reviews": "Alle Bewertungen löschen",
  "delete_reviews_warning": "Dies löscht dauerhaft alle Ihre Bewertungen. Diese Aktion kann nicht rückgängig gemacht werden.",
  "delete_account": "Konto löschen",
  "delete_account_warning": "Warnung: Diese Aktion kann nicht rückgängig gemacht werden. Dadurch werden Ihr Konto und alle Ihre Daten dauerhaft von unseren Servern gelöscht.",
  "account_deleted_success": "Ihr Konto wurde erfolgreich gelöscht",
  "account_deletion_failed": "Fehler beim Löschen des Kontos",
  "reviews_deleted_success": "Alle Ihre Bewertungen wurden erfolgreich gelöscht",
  "reviews_deletion_failed": "Fehler beim Löschen der Bewertungen",
  "films_deleted_success": "Alle Ihre Filme wurden erfolgreich gelöscht",
  "films_deletion_failed": "Fehler beim Löschen der Filme",
  "confirm_delete_films": "Sind Sie sicher, dass Sie alle Ihre Filme löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
  "confirm_delete_reviews": "Sind Sie sicher, dass Sie alle Ihre Bewertungen löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
  "confirm_delete_account": "Sind Sie sicher, dass Sie Ihr Konto löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
  "create_username": "Benutzernamen erstellen",
  "username_required_description": "Bitte erstellen Sie einen Benutzernamen für Ihr Konto. Benutzernamen müssen eindeutig sein und können Buchstaben, Zahlen und Unterstriche enthalten.",
  "username": "Benutzername",
  "username_placeholder": "Geben Sie einen Benutzernamen ein",
  "username_requirements": "Der Benutzername muss zwischen 4 und 25 Zeichen lang sein und darf nur Buchstaben, Zahlen und Unterstriche enthalten.",
  "save_username": "Benutzernamen speichern",
  "username_taken": "Dieser Benutzername ist bereits vergeben",
  "username_set_success": "Benutzername erfolgreich festgelegt",
  "username_set_error": "Fehler beim Festlegen des Benutzernamens"
};
